import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import { KCFColor } from 'styles/themes/KCFColor';

export type DeleteIconProps = {
    /**
     * Icon to display.
     */
    icon?: IconDefinition;
    /**
     * Color of the icon.
     */
    color?: string;
    /**
     * The `aria-label` to apply.
     */
    ariaLabel?: string;
    /**
     * The title attribute to apply to the icon.
     */
    title?: string;
    /**
     * Classes to apply to the icon element.
     */
    className?: string;
} & Pick<FontAwesomeIconProps, 'size' | 'aria-hidden' | 'aria-label'>;

function DeleteIcon({
    size,
    icon,
    className,
    color,
    title,
    'aria-hidden': ariaHidden,
    'aria-label': ariaLabel,
}: DeleteIconProps) {
    const commonProps = {
        className,
        'aria-hidden': ariaHidden,
    };

    return (
        <FontAwesomeIcon
            {...commonProps}
            icon={icon ?? faTrash}
            color={color ?? KCFColor.red1}
            title={title ?? 'Delete'}
            aria-label={ariaLabel ?? 'Delete'}
            size={size ?? size}
        />
    );
}
const memoDeleteIcon = memo(DeleteIcon);
export { memoDeleteIcon as DeleteIcon };
